import { useEffect } from "react";

export default function usePreventNumberInputScroll() {
    useEffect(() => {
        const isNumberInput = (el) => el instanceof HTMLInputElement && el.type === "number";
        const handleWheel = (e) => {
            const activeEl = document.activeElement;
            if (isNumberInput(activeEl)) {
                activeEl.blur(); e.preventDefault();
            }
        };
        const handleKeyDown = (e) => {
            if (isNumberInput(e.target) && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
                e.preventDefault();
            }
        };
        const wheelOptions = { passive: false, capture: true };
        document.addEventListener("wheel", handleWheel, wheelOptions);
        document.addEventListener("keydown", handleKeyDown, true);
        return () => {
            document.removeEventListener("wheel", handleWheel, wheelOptions);
            document.removeEventListener("keydown", handleKeyDown, true);
        };
    }, []);
}